import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TakingCareOfYourGiants from "./sections/TakingCareOfYourGiants";
import TheHiddenCostOfMissedLeads from "./sections/TheHiddenCostOfMissedLeads";
import TheHearthHeritage from "./sections/TheHearthHeritage";
import OurCarePathways from "./sections/OurCarePathways";
import TheDirectorsPath from "./sections/TheDirectorsPath";
import UltimasDoBlog from "./sections/UltimasDoBlog";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TakingCareOfYourGiants />
      <TheHiddenCostOfMissedLeads />
      <TheHearthHeritage />
      <OurCarePathways />
      <TheDirectorsPath />
      <UltimasDoBlog />
      <Footer />
    </div>;
}